/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiOfficesMutationRequest,
  PostApiOfficesMutationResponse,
} from '../models/PostApiOffices.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiOfficesMutationResponseSchema,
  postApiOfficesMutationRequestSchema,
} from '../zod/postApiOfficesSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiOfficesMutationKey = () =>
  [{ url: '/api/offices' }] as const;

export type PostApiOfficesMutationKey = ReturnType<
  typeof postApiOfficesMutationKey
>;

/**
 * {@link /api/offices}
 */
export async function postApiOffices(
  data: PostApiOfficesMutationRequest,
  config: Partial<RequestConfig<PostApiOfficesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiOfficesMutationRequestSchema.parse(data);
  const res = await request<
    PostApiOfficesMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiOfficesMutationRequest
  >({
    method: 'POST',
    url: `/api/offices`,
    data: requestData,
    ...requestConfig,
  });
  return postApiOfficesMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/offices}
 */
export function usePostApiOffices<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiOfficesMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiOfficesMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiOfficesMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiOfficesMutationKey();

  return useMutation<
    PostApiOfficesMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiOfficesMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiOffices(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
